"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formatCents_1 = __importDefault(require("./formatCents"));
exports.default = formatCents_1.default;
//# sourceMappingURL=index.js.map